import { ModuleSidebar } from "@/components/modules/ModuleSidebar";
import { MODULES } from "@/lib/modules/registry";

export function ResidenciaSidebar() {
  return <ModuleSidebar config={MODULES.residencia} />;
}
